// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { API_URL } from "../../../config/globalConfig";
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';


/** 获取 Token */
const getToken = () => {
  return sessionStorage.getItem('token');
};

/** 创建请求配置 */
const createRequestConfig = (additionalHeaders = {}) => {
  const token = getToken();
  console.log("token:" + token);
  const headers = {
    Authorization: token ? `Bearer ${token}` : '',
    ...additionalHeaders,
  };
  return {
    headers,
  };
};

/** 获取当前的用户 GET /api/currentUser */
// export async function currentUser(options?: { [key: string]: any }) {
//   return request<{
//     data: API.CurrentUser;
//   }>(API_URL+'/api/currentUser', {
//     method: 'GET',
//     // credentials: 'include', // 添加这个属性以确保请求携带 Cookie
//     withCredentials: true, // 确保请求携带 cookie
//     ...createRequestConfig(),
//     ...(options || {}),
//   });
// }

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  const config = {
    method: 'GET',
    url: `${API_URL}/api/currentUser`,
    withCredentials: true, // 确保请求携带 cookie
    ...options, // 添加其他配置项
  };

  return axios.request<API.CurrentUser>(config);
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...createRequestConfig(),
    ...(options || {}),
  });
}


